import { t } from '@lingui/macro';

const ERRORS = {
    field_required: t`This field is required`,
    fill_required_fields: t`Please fill out the required details`,
    password_confirmation: t`The password confirmation does not match`,
    password_confirm: t`Please confirm the password`,
    email_taken: t`Email already taken by someone else`,
    email_not_found: t`We can't find the email address`,
    email_not_valid: t`Please enter a valid email address`,
    username_generic: t`Username invalid, or already in use`,
    family_generic: t`Something has gone wrong`,
    password_current_invalid: t`The password your entered is not valid`,
    login_wrong_credentials: t`Sorry, we couldn't find an account with the credentials provided`,
    login_server_error: t`Sorry, there was an error while accessing your account. Please, try again later`,
    facebook_unknown: t`There was an unknown error while connecting to Facebook. Please, try again later`,
    facebook_no_account: t`Looks like there is no Yousician profile with this Facebook account.`,
    facebook_already_signed_up: t`Looks like this Facebook account is already connected to another Yousician profile. Please use a different Facebook account.`,
    facebook_already_in_use: t`The Facebook profile you are trying to link is alredy linked to another Yousician account`,
    facebook_wrong_account: t`Sorry, the Facebook profile you used is not linked with the account you are currently logged in`,
    apple_unknown: t`There was an unknown error while connecting to Apple. Please, try again later`,
    apple_not_registered: t`Seems like you have not signed up for Yousician using this Apple id. Sign up by Apple id is currently available in our iPhone apps.`,
    apple_user_canceled: t`You have canceled the Apple sign in process`,
    password_recover_generic: t`There was an error while sending the password reset email. Please, try again later`,
    password_reset_generic: t`There was an error while resetting your password. Please, try again later`,
    deleting_account: t`There was an error while deleting your account. Please, try again later`,
    download_data: t`There was an error while creating your archive. Please, try again later`,
    credit_card_number_invalid: t`Please enter a valid credit card number.`,
    credit_card_expiry_invalid: t`Please enter a valid date.`,
    updating_payment_failed: t`There was an error while updating your payment details. Please, make sure you entered everything correctly or try again later.`,
    updating_payment_multiple_failed_attemps: t`Your payment details couldn't be updated because there were too many attempts. Please try again later.`,
    payment_invalid_cvc: t`The payment verification failed. Please check your card expiration date and/or CVC code.`,
    payment_card_declined: t`Payment declined. We recommend you try again and if it still fails contact your bank to make sure the card has correct settings for online payments.`,
    payment_paypal: t`There was an error while setting up the PayPal payment. Please, try again later or use a different payment method.`,
    payment_paypal_cancelled: t`You have cancelled the Paypal payment.`,
    payment_failed: t`Payment failed`,
    payment_failed_again: t`Payment verification failed again`,
    payment_declined_bank: t`Your payment was declined by your bank`,
    payment_multiple_failed_attempts: t`Your payment couldn’t be completed`,
    payment_multiple_failed_retry: t`There were too many payment attempts. Please try again later.`,
    invalid_number: t`Please check your card number.`,
    invalid_cvc: t`Please check your card CVC code.`,
    invalid_expiry: t`Please check your card's expiration date.`,
    card_declined: t`Please check your card details (date, CVC code, name ...)`,
    not_supported: t`Your card is sadly not yet supported.`,
};
export default ERRORS;
